import { HubJsonRpcRequest } from '../../../api/HubJsonRpcRequest';
import { ResetEmailPasswordResponse } from '../../../api/hub-responses/reset-email-password-response';
import { HubApiMethods } from '../../../constants/HubApiMethods';
import { container } from '../../../utils/container/container';
import { FeatureFlagsLoader } from '@scorewarrior/rubens_web_lib';
import { ServiceIds } from '../../../utils/container/service-ids';
import { FlagNames } from '../../../utils/feature-flags/flag-names';
import { getHubApi } from '../accountServiceApi/getAccountServiceApi';

export type ResetEmailPasswordRequest = {
    email: string,
    locale: string
}

export function resetEmailPassword(data: ResetEmailPasswordRequest): Promise<ResetEmailPasswordResponse> {
    const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
    const isHubApiEnabled = ffLoader.get(FlagNames.SITE_HUB_API_ENABLED)?.isOn();

    if (!isHubApiEnabled) {
        return HubJsonRpcRequest.makeRequest<ResetEmailPasswordResponse, ResetEmailPasswordRequest>(
            HubApiMethods.RESET_EMAIL_PASSWORD,
            data,
            window.app.deviceIdentifier
        );
    } else {
        const hubApi = getHubApi();
        return hubApi.resetEmailPassword(window.app.deviceIdentifier, data) as Promise<ResetEmailPasswordResponse>;
    }
}
